module.exports = __webpack_public_path__ + "static/media/human-advantage-plus.f3c051c2.svg";